export enum CertificatesTranslationKeyEnum {
  PageTitle = "certificates.pageTitle",
  MobileTitle = "certificates.mobileTitle",
  EmptyTitle = "certificates.empty.title",
  EmptyBody = "certificates.empty.body",
  EmptyCta = "certificates.empty.cta",
  SearchNoResults = "certificates.search.noResults",
  LoadError = "certificates.loadError",
  Retry = "certificates.retry",
  ScaffoldListAria = "certificates.scaffoldListAria",
  Loading = "certificates.loading",
  LoadMore = "certificates.loadMore",
  ApprovedOn = "certificates.approvedOn",
  ShareOnLabel = "certificates.share.onLabel",
  ShareOpenMenu = "certificates.share.openMenu",
  ShareCopyLink = "certificates.share.copyLink",
  ShareCopyLinkSuccess = "certificates.share.copyLinkSuccess",
  ShareCopyLinkError = "certificates.share.copyLinkError",
  ShareDownload = "certificates.share.download",
  DownloadError = "certificates.download.error",
  DownloadBusy = "certificates.download.busy",
  CardGridAria = "certificates.cardGridAria",
  CardPreviewPlaceholderAria = "certificates.card.previewPlaceholderAria",
}
